import React from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { useLocation } from "react-router-dom";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { auth } from '../firebase';
import { Card } from 'react-bootstrap';

export default function LoginPage() {
  let location = useLocation() as any;

  let from = location.state?.from?.pathname || '/account/teams';

  const uiConfig = {
    signInFlow: 'popup',
    signInSuccessUrl: from,
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID
    ],
    callbacks: {
      signInSuccessWithAuthResult: (authResult: any, redirectUrl: any) => {
        // console.log('signInSuccessWithAuthResult', authResult);
        // auth.signin(authResult.user).then(() => navigate(from, { replace: true }));
        return true;
      },
    }
  };

  return <Card style={{ maxWidth: '410px' }}>
    <Card.Header>
      <img src='/logo.svg' alt='DeckStamp logo' />
    </Card.Header>
    <Card.Body>
      <h2>Take back control of your process</h2>
      <p>Let's get back at it and stamp some decks.</p>
      <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
      <br />
      <p>Don't have an account? <strong><a href='/signup'>Sign up free</a></strong></p>
    </Card.Body>
  </Card>;
}
